import { render, staticRenderFns } from "./BasicForm.vue?vue&type=template&id=1e7f371b"
import script from "./BasicForm.vue?vue&type=script&lang=ts"
export * from "./BasicForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports